import { Controller } from "@hotwired/stimulus"

// Kosten filter: a year button fills Von/Bis with that calendar year.
export default class extends Controller {
  static targets = ["from", "to"]

  set({ params: { from, to } }) {
    this.fromTarget.value = from
    this.toTarget.value = to
  }
}
